module.exports = "/packs/multicreator_banner-26639c579747715f734554f4a23cc392.png";